// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"558":"52691a5b","649":"5ecef9d0","650":"0d98e2fa","726":"add37379"}[chunkId] + ".chunk.js";
};